import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { constants } from '@constants/constants';
import { environment } from '@environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Redirects subscription apps (CEMS, CIMS, GPA, GFD, PERI) to /maintenance on 503 responses; skipped for the back-office.
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.orgId === constants.orgId.admin.value) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 503) {
          const router = this.injector.get(Router);

          if (router.url.startsWith('/maintenance')) {
            return throwError(() => error);
          }

          const returnUrlKey = constants.localStorageKeys.maintenanceReturnUrl;
          const savedReturnUrl = localStorage.getItem(returnUrlKey);

          if (!savedReturnUrl?.startsWith('/')) {
            localStorage.setItem(returnUrlKey, router.url);
          }

          router.navigateByUrl('/maintenance');
        }

        return throwError(() => error);
      })
    );
  }
}
